// extracted by mini-css-extract-plugin
module.exports =  {"room-type-filter":"_0bc5e8de02--room-type-filter--R2wo1","skeleton-filter":"_0bc5e8de02--skeleton-filter--VGWUq"};